<template>

  <div class="hello py-4">
    <h1>{{ msg }}</h1>
  </div>

  <div>
    <va-alert color="danger" class="mb-4">
      Quello che stavi cercando non è più disponibile però qui potresti trovare altro di tuo interesse.
    </va-alert>
  </div>

  <div>
    <va-form ref="form">
      <va-input
          class="mb-4 mr-4"
          label="Nome"
          v-model="inputValue"
          stateful
      />
      <va-button class="mb-4 mr-4" @click="inputValue = ''; currentPage = 1; this.getItems(1);">
        Cancella
      </va-button>
      <va-button class="mb-4 mr-4" @click="currentPage = 1; this.getItems(1, inputValue)">
        Cerca
      </va-button>
    </va-form>
  </div>

  <div class="row">
    <div class="flex md4 lg2 pa-2" v-for="(item) in items" :key="item.id">
      <va-card v-bind:href="item.link" target="_blank">
        <va-image v-bind:src="item.gallery_images_src[0].src" v-bind:alt="item.title.rendered"/>
        <va-card-title v-html="item.title.rendered"/>
        <va-card-content v-html="item.excerpt.rendered"/>
        <va-card-actions align="stretch" vertical>
          <va-button>Scopri di più</va-button>
        </va-card-actions>
      </va-card>
    </div>
  </div>

  <div class="error">
    <ul v-if="errors && errors.length">
      <li v-for="(error) in errors" :key="error">
        {{ error.message }}
      </li>
    </ul>
  </div>

  <va-pagination v-model="currentPage" :pages="this.totPages" class="mt-4"/>

</template>


<script>
import axios from 'axios';

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      items: [],
      errors: [],
      currentPage: 1,
      inputValue: '',
      exclusions: [],
      totPages: 10,
    }
  },
  methods: {
    getItems(page, search = '') {
      axios.get('https://punterforum.com/wp-json/wp/v2/listing', {
        params: {
          per_page: 12,
          page: page,
          exclude: this.exclusions,
          search: search,
        }
      })
          .then(response => {
            this.items = response.data;
            this.totPages = Math.ceil(response.headers["x-wp-total"] / 12)
          })
          .catch(response => {
            this.errors.push(response);
          });
    }
  },
  created() {
    this.getItems(this.currentPage);
  },
  mounted() {
    document.title = this.msg;
  },
  watch: {
    'currentPage': function (newValue) {
      this.getItems(newValue);
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 2em;
  line-height: 1.5;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
